import React from 'react';
import '../../scss/textos.scss';

export default class LabelCorpoTexto extends React.Component {
  render() {
    return <label className={'labelTextField ' + this.props.className}>{this.props.label}</label>;
  }
}
